var React = require('react');

function IconCheckSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M432.1 861.9L66.9 566.7c-2.5-2.1-2.9-6-.6-8.6l94.9-104.2c2.1-2.3 5.7-2.5 8-.6l252.7 204.8 415.2-492c2.1-2.5 5.7-2.7 8.2-.8L958.2 258c2.5 2.1 2.9 5.8.8 8.4L440.1 861.1c-2.2 2.3-5.7 2.7-8 .8z"}));
}

IconCheckSolid.displayName = "IconCheckSolid";

IconCheckSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCheckSolid;

IconCheckSolid.default = IconCheckSolid;
